/**
 * Smooth Scroll functionality
 *
 *
 * @class rlSmoothScroll
 * @memberOf jQuery.fn
 */

(function($) {

    $.fn.rlSmoothScroll = function() {

        // AF: moved here from rl-QuickNav so that rl-QuickNav can be selectively loaded
        // Add smooth scrolling to all anchor links across the site
        $('a').on('click', function(event) {

            // check to see if hash is for accordions
            var accStr = this.hash.indexOf("#acc-target") >= 0;

            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "" && accStr !== true &&
                !$(this).hasClass("accordion-link") &&
                !$(this).parents().hasClass("quicknav-menu") &&
                !$(this).parent().hasClass("custom-options") &&
                !$(this).parents().hasClass("panelnav") &&
                !$(this).parents().hasClass("internalpagenavcontainerblock") &&
                !$(this).hasClass("externalbutton")) {

                // Prevent default anchor click behavior
                //check if path is on same url/page and prevent default behaviour otherwise do nothing
                if (this.pathname === window.location.pathname &&
                    this.protocol === window.location.protocol &&
                    this.host === window.location.host) {
                    event.preventDefault();
                }

                $('a').each(function() {
                    $(this).removeClass('active');
                })
                $(this).addClass('active');

                // Store hash
                var hash = this.hash;

                if ($(window).width() <= 767.98) {
                    var headerHeight = 80;
                } else if ($(window).width() <= 991.98) {
                    var headerHeight = 110;
                } else {
                    var headerHeight = 90;
                }
                //767.98 and 991.98 taken from bs4's media-breakpoint-up media queries

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').stop().animate({
                    'scrollTop': $(hash).offset().top - headerHeight
                }, 800, 'swing');
            } // End if
        });
    }

}(jQuery));
